module.exports = __webpack_public_path__ + "img/flusher_parked.6553c3b5.svg";